import { connect } from 'react-redux'
import { jsProvider as Provider } from './Features.bs'

export default connect(state => ({
  token: state.session.token,
  initializing: state.session.initializing,
  isLoggingOut: state.session.isLoggingOut,
}))(Provider)
